import * as Yup from 'yup';

export const orderValidationSchema = Yup.object().shape({
  deliveryDate: Yup.date().required('The delivery date is required'),
  orderLines: Yup.array().of(
    Yup.object().shape({
      productId: Yup.number().required('The product is required'),
      total: Yup.number().required('The line total is required')
    })
  )
});



// WEBPACK FOOTER //
// ./src/validation/order.js